module.exports = __webpack_public_path__ + "static/media/ad-min.e6ac1fde.png";